{{deadline.includes('ago') ? '❗️' : deadline.includes('hours') || deadline.includes('minutes') || deadline.includes('1 day') ? '⚠️' : ''}} {{deadline}}